angular.module('unica_invitation_transfer.invitation_transfer_controllers')

.controller('InvitationTransferCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	InvitationTransferCreateService,
	InvitationListListService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.getTransferList( $stateParams.event_id );

	$scope.showLoader();
	InvitationListListService
		.fullList( $stateParams.event_id )
		.then(function(data) {
			$scope.hideLoader();

			if ( data ) {

				angular.forEach(data, function(il, key) {
					if ( il.stage ) {
						data[key].stage.from_date = moment.unix( il.stage.from_date ).toDate();
						data[key].stage.to_date   = moment.unix( il.stage.to_date ).toDate();
					}
				});

				$scope.invitationsLists = data;
			}
		});


	$rootScope.getInvitationsByEventNoTransfers( $stateParams.event_id );

	$rootScope.invitationTransferData = {
		event_id: $stateParams.event_id
	};

	$scope.saveInvitationTransfer = function() {
		$scope.showLoader();

		var invitationTransferData = angular.copy($rootScope.invitationTransferData);
		invitationTransferData = $scope.parseInvitationTransferFromDateToTimestamp(invitationTransferData);

		InvitationTransferCreateService
			.create( invitationTransferData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg( data + ' transfer assegnati!', '');
					$state.go('app.hospitality.invitation_transfer_list', { event_id: $stateParams.event_id });
				}
			});
	};

});
